import React from "react";
import { Route, Switch } from "react-router-dom";
import { Flex } from "@jsq/ds/core";
import CanopyRolesPage from "./CanopyRolesPage";
import * as styles from "./styles_vanilla.css";
import UsersPage from "./UsersPage";
import WorkspaceRolesPage from "./WorkspaceRolesPage";
import WorkspacesPage from "./WorkspacesPage";

const UserAndRoles: React.FC = () => {
  return (
    <Flex data-testid="user-and-roles-root" className={styles.wrapperContainer}>
      <div className={styles.layoutContainer}>
        <Switch>
          <Route path="/users" exact>
            <UsersPage />
          </Route>
          <Route path="/users/workspaces" exact>
            <WorkspacesPage />
          </Route>
          <Route path="/users/canopy-roles" exact>
            <CanopyRolesPage />
          </Route>
          <Route path="/users/workspace-roles" exact>
            <WorkspaceRolesPage />
          </Route>
        </Switch>
      </div>
    </Flex>
  );
};

export default UserAndRoles;
